import clickSound from 'components/Selfiebooth/utils/data/click-sound.base64.json'

export function clickAudio() {
  let audio = new Audio('data:audio/mp3;base64,' + clickSound.base64)
  audio.play()
}